import React from 'react';
import MediaLibraryTemplate from "./MediaLibraryTemplate";
import SmallFileBlock from "./SmallFileBlock";

class MediaLibrarySmallBlock extends React.Component{

  constructor(props) {
    super(...arguments);
  }

  render() {
    return <MediaLibraryTemplate Component={SmallFileBlock} {...this.props}/>
  }

}

export default MediaLibrarySmallBlock;
